import apiClient from 'enrollment-platform/api/enrollment-platform-client/api-client'

export type AutoTermReportRecord = {
  firstName: string
  lastName: string
  fileCompanyEmployeeId: string
  fileEmploymentStatus: string
  terminationDate: string
  ssn: string
  employeePublicKey: string
  memberCompanyEmployeeId: string
  memberEmploymentStatus: string
}

export type CensusIntegrationUploadDto = {
  id: string
  clientPublicKey: string
  companyName: string | null
  fileName: string | null
  importId: string | null
  censusStatus: string
  censusProcessedMs: number
  totalRecords: number | null
  eligible: number | null
  ineligible: number | null
  duplicateRecords: number | null
  newRecords: number | null
  updateRecords: number | null
  errorRecords: number | null
  censusError: string | null
  autoTermStatus: string
  autoTermProcessedMs: number
  alreadyTerminated: number
  alreadyTerminatedRecords: AutoTermReportRecord[]
  newEnqueued: number
  missingTerminationDate: number
  missingTerminationDateRecords: AutoTermReportRecord[]
  ambiguousMemberMatch: number
  ambiguousMemberRecords: AutoTermReportRecord[]
  autoTermError: string | null
  createdAt: string
}

export type CensusIntegrationUploadDownloadsDto = {
  flexspringUrl: string | null
  transformedUrl: string | null
}

export const getCensusIntegrationUploads = async (
  clientPublicKey?: string
): Promise<CensusIntegrationUploadDto[]> => {
  const ret = await apiClient.get<CensusIntegrationUploadDto[]>(
    'census-files/integrations/uploads',
    { params: clientPublicKey ? { clientPublicKey } : {} }
  )
  return ret.data
}

export const getCensusIntegrationUploadDownloads = async (
  id: string
): Promise<CensusIntegrationUploadDownloadsDto> => {
  const ret = await apiClient.get<CensusIntegrationUploadDownloadsDto>(
    `census-files/integrations/uploads/${id}/downloads`
  )
  return ret.data
}
